/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadyiteminstagram3Inputs */

const en_searchreadyiteminstagram3 = /** @type {(inputs: Searchreadyiteminstagram3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const de_searchreadyiteminstagram3 = /** @type {(inputs: Searchreadyiteminstagram3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

/**
* | output |
* | --- |
* | "Instagram" |
*
* @param {Searchreadyiteminstagram3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadyiteminstagram3 = /** @type {((inputs?: Searchreadyiteminstagram3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadyiteminstagram3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadyiteminstagram3(inputs)
	return de_searchreadyiteminstagram3(inputs)
});
export { searchreadyiteminstagram3 as "searchReadyItemInstagram" }